import { connect } from 'react-redux';
import { formValueSelector, change as changeFormValue } from 'redux-form';
import { constants } from '@eti/utils';
import { BAGGAGE_VALUES, getNumberOfUnits, hasCurrentTravelerSelectedBaggage } from '../../common/utils/baggageUtils';
import { CHECK_IN_BAGGAGE } from '../../../products';
import CheckInBaggagePrimaryFlow from '../components/CheckInBaggagePrimaryFlow';
import { getTravelersPrimaryFlow } from '../utils/checkInBaggageUtils';
const productName = CHECK_IN_BAGGAGE.name;
export const setChoiceValueForTraveler = (form, value, dispatch, order, travelerId) => {
  var _order$sellSpecificat, _price$markup$value, _price$markup, _price$price$value, _price$price;
  const baggageSpecification = ((_order$sellSpecificat = order.sellSpecification) === null || _order$sellSpecificat === void 0 ? void 0 : _order$sellSpecificat.sellPriceBaggage) || [];
  const {
    options = []
  } = (baggageSpecification === null || baggageSpecification === void 0 ? void 0 : baggageSpecification.find(currTraveler => String(currTraveler === null || currTraveler === void 0 ? void 0 : currTraveler.travelerId) === String(travelerId))) || {};
  const {
    ancillaryCarrierPriceBreakdowns = [],
    price = null,
    numberOfUnits = 0,
    weight = 0,
    weightUnit = ''
  } = options.find(option => value === BAGGAGE_VALUES.TRUE || (value === null || value === void 0 ? void 0 : value.includes(String(option.weight)))) || {};
  dispatch(changeFormValue(form, `${productName}.${productName}-traveler-${travelerId}`, {
    value,
    id: travelerId,
    ...(ancillaryCarrierPriceBreakdowns.length > 0 && {
      ancillaryCarrierPriceBreakdowns
    }),
    markup: (_price$markup$value = price === null || price === void 0 || (_price$markup = price.markup) === null || _price$markup === void 0 ? void 0 : _price$markup.value) !== null && _price$markup$value !== void 0 ? _price$markup$value : 0,
    priceRaw: (_price$price$value = price === null || price === void 0 || (_price$price = price.price) === null || _price$price === void 0 ? void 0 : _price$price.value) !== null && _price$price$value !== void 0 ? _price$price$value : 0,
    numberOfPieces: numberOfUnits,
    weight,
    weightUnit
  }));
};
export const setCombinedChoiceValueForTraveler = (form, secondBagTraveler, value, dispatch, order, travelerId, orderSecondBag) => {
  var _order$sellSpecificat2, _baggageSpecification, _orderSecondBag$sellS, _price$price2, _price$markup2;
  const {
    markup: secondbagmarkup = 0,
    price: secondbagprice = 0
  } = secondBagTraveler || {};
  const baggageSpecificationFirstBag = (_order$sellSpecificat2 = order.sellSpecification) === null || _order$sellSpecificat2 === void 0 || (_order$sellSpecificat2 = _order$sellSpecificat2.sellPriceBaggage) === null || _order$sellSpecificat2 === void 0 ? void 0 : _order$sellSpecificat2[0];
  const {
    weight: weightOfFirstBag,
    numberOfUnits: piecesOfFirstBag,
    weightUnit: weightUnitOfFirstBag,
    price
  } = (_baggageSpecification = baggageSpecificationFirstBag === null || baggageSpecificationFirstBag === void 0 ? void 0 : baggageSpecificationFirstBag.options[0]) !== null && _baggageSpecification !== void 0 ? _baggageSpecification : {};
  const baggageSpecificationSecondBag = (_orderSecondBag$sellS = orderSecondBag.sellSpecification) === null || _orderSecondBag$sellS === void 0 || (_orderSecondBag$sellS = _orderSecondBag$sellS.sellPriceBaggage) === null || _orderSecondBag$sellS === void 0 ? void 0 : _orderSecondBag$sellS[0];
  const {
    weight: weightOfSecondBag,
    numberOfUnits: piecesOfSecondBag,
    weightUnit: weightUnitOfSecondBag
  } = (baggageSpecificationSecondBag === null || baggageSpecificationSecondBag === void 0 ? void 0 : baggageSpecificationSecondBag.options[0]) || {};
  const firstBagPrice = price === null || price === void 0 || (_price$price2 = price.price) === null || _price$price2 === void 0 ? void 0 : _price$price2.value;
  const firstBagMarkup = price === null || price === void 0 || (_price$markup2 = price.markup) === null || _price$markup2 === void 0 ? void 0 : _price$markup2.value;
  const formattedValue = value === BAGGAGE_VALUES.COMBINED;
  dispatch(changeFormValue(form, `${productName}.${productName}-traveler-${travelerId}`, {
    value,
    id: travelerId,
    ...(formattedValue && {
      markup: (secondbagmarkup !== null && secondbagmarkup !== void 0 ? secondbagmarkup : 0) + (firstBagMarkup !== null && firstBagMarkup !== void 0 ? firstBagMarkup : 0),
      priceRaw: (secondbagprice !== null && secondbagprice !== void 0 ? secondbagprice : 0) + (firstBagPrice !== null && firstBagPrice !== void 0 ? firstBagPrice : 0),
      numberOfPieces: weightOfFirstBag === weightOfSecondBag ? (piecesOfFirstBag || 0) + (piecesOfSecondBag || 0) : piecesOfFirstBag,
      piecesOfSecondBag,
      weight: weightOfFirstBag,
      weightOfSecondBag,
      weightUnit: weightUnitOfFirstBag,
      weightUnitOfSecondBag
    })
  }));
};
const getFilteredSecondBagTravelers = orderSecondBag => {
  const secondBagTravelers = getTravelersPrimaryFlow(orderSecondBag);
  return (secondBagTravelers === null || secondBagTravelers === void 0 ? void 0 : secondBagTravelers.filter(({
    ageType
  }) => ageType !== constants.ageTypes.INFANT)) || [];
};
export const onChange = (dispatch, {
  form,
  order,
  orderSecondBag
}) => (selectionValue, selectedTravelerId, shouldApplySelectionToAll) => {
  const secondBagTravelers = getFilteredSecondBagTravelers(orderSecondBag);
  const selectedSecondBagTraveler = secondBagTravelers.find(({
    id
  }) => id === selectedTravelerId);
  const triggerChange = val => {
    var _order$travelers;
    const isFirstTraveler = selectedTravelerId === ((_order$travelers = order.travelers) === null || _order$travelers === void 0 || (_order$travelers = _order$travelers[0]) === null || _order$travelers === void 0 ? void 0 : _order$travelers.id);
    const applySelectionToAll = isFirstTraveler && shouldApplySelectionToAll;
    const handleCombinedChoice = () => {
      if (setCombinedChoiceValueForTraveler) {
        if (applySelectionToAll) {
          var _order$travelers2;
          dispatch(changeFormValue(form, `${productName}.shouldApplySelectionToAll`, applySelectionToAll));
          (_order$travelers2 = order.travelers) === null || _order$travelers2 === void 0 || _order$travelers2.forEach(({
            ageType,
            id
          }) => {
            const travelerId = id !== null && id !== void 0 ? id : '';
            if (ageType === constants.ageTypes.INFANT) {
              return;
            }
            const currentSecondBagTraveler = secondBagTravelers.find(secondBagTrav => secondBagTrav.id === travelerId);
            setCombinedChoiceValueForTraveler(form, currentSecondBagTraveler, val, dispatch, order, travelerId, orderSecondBag);
          });
        } else {
          dispatch(changeFormValue(form, `${productName}.shouldApplySelectionToAll`, false));
          setCombinedChoiceValueForTraveler(form, selectedSecondBagTraveler, val, dispatch, order, selectedTravelerId, orderSecondBag);
        }
      }
    };
    const handleIndividualChoice = () => {
      if (setChoiceValueForTraveler) {
        if (applySelectionToAll) {
          var _order$travelers3;
          dispatch(changeFormValue(form, `${productName}.shouldApplySelectionToAll`, applySelectionToAll));
          (_order$travelers3 = order.travelers) === null || _order$travelers3 === void 0 || _order$travelers3.forEach(({
            ageType,
            id
          }) => {
            if (ageType === constants.ageTypes.INFANT) {
              return;
            }
            setChoiceValueForTraveler(form, val, dispatch, order, id !== null && id !== void 0 ? id : '');
          });
        } else {
          dispatch(changeFormValue(form, `${productName}.shouldApplySelectionToAll`, false));
          setChoiceValueForTraveler(form, val, dispatch, order, selectedTravelerId);
        }
      }
    };
    if (val === BAGGAGE_VALUES.COMBINED) {
      handleCombinedChoice();
    } else {
      handleIndividualChoice();
    }
  };
  triggerChange(selectionValue);
};
export const onChangeAll = (dispatch, {
  form,
  order,
  orderSecondBag
}) => (checkboxValue, firstTravelerSelectionValue) => {
  var _order$travelers4;
  const secondBagTravelers = getFilteredSecondBagTravelers(orderSecondBag);
  dispatch(changeFormValue(form, `${productName}.shouldApplySelectionToAll`, checkboxValue));
  (_order$travelers4 = order.travelers) === null || _order$travelers4 === void 0 || _order$travelers4.slice(1).forEach(({
    ageType,
    id
  }) => {
    const travelerId = id !== null && id !== void 0 ? id : '';
    if (ageType === constants.ageTypes.INFANT) {
      return;
    }
    const secondBagTraveler = secondBagTravelers.find(secondBagTrav => secondBagTrav.id === travelerId);
    const value = checkboxValue ? String(firstTravelerSelectionValue) : '';
    if (firstTravelerSelectionValue === BAGGAGE_VALUES.COMBINED) {
      setCombinedChoiceValueForTraveler(form, secondBagTraveler, value, dispatch, order, travelerId, orderSecondBag);
    } else {
      setChoiceValueForTraveler(form, value, dispatch, order, travelerId);
    }
  });
};
const mapStateToProps = (state, {
  form,
  travelerNumber,
  isVI
}) => {
  var _formValueSelector;
  const shouldApplySelectionToAll = formValueSelector(form)(state, `${productName}.shouldApplySelectionToAll`);
  const firstTravelerSelectionValue = (_formValueSelector = formValueSelector(form)(state, `${productName}.${productName}-traveler-0`)) === null || _formValueSelector === void 0 ? void 0 : _formValueSelector.value;
  const isCheckedBaggageSelected = hasCurrentTravelerSelectedBaggage(productName, form, state, travelerNumber);
  return {
    isCheckedBaggageSelected,
    isVI,
    shouldApplySelectionToAll: shouldApplySelectionToAll !== null && shouldApplySelectionToAll !== void 0 ? shouldApplySelectionToAll : true,
    productName,
    isFirstTraveler: travelerNumber === 0,
    firstTravelerSelectionValue,
    totalBaggageQuantity: getNumberOfUnits(productName, form)(state)
  };
};
const mapDispatchToProps = (dispatch, {
  form,
  order,
  orderSecondBag
}) => {
  return {
    onChange: onChange(dispatch, {
      form,
      order,
      orderSecondBag
    }),
    onChangeAll: onChangeAll(dispatch, {
      form,
      order,
      orderSecondBag
    })
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CheckInBaggagePrimaryFlow);
//# sourceMappingURL=CheckInBaggagePrimaryFlowContainer.js.map